import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'unsaved-changes-dialog',
  templateUrl: 'unsaved-changes-dialog.component.html',
})
export class UnsavedChangesDialogComponent {

}
